import {insertLab, getListLab, getLabById, updateLab, getUserListByLabIdIsNull, doInviteUser,
  removeUserAndRoleFromLab, getLabUserList, getLabRoleCv, modifyLabUserRole, doQuitLab, modifyLabNameInSample, countListLab, getLabUserListCount} from 'api/lab'
const lab = {
  state: {
    mapDetail: {
      lng: '',
      lat: '',
      address: ''
    },
    listLab: [],
    labListNum: 0,
    labDetail: {}
  },
  mutations: {
    SET_MAPDETAIL: (state, res) => {
      state.mapDetail.lng = res.lng
      state.mapDetail.lat = res.lat
      state.mapDetail.address = res.address
    },
    SET_LABLIST (state, data) {
      state.listLab = data.result
      state.labListNum = data.totalCount
    },
    SET_LABDETAIL (state, data) {
      state.labDetail = data
    }
  },
  actions: {
    getMapdetail ({ commit }, params) {
      commit('SET_MAPDETAIL', params)
    },
    doInviteUser ({commit}, data) {
      return new Promise((resolve, reject) => {
        doInviteUser(data).then((res) => {
          console.log(res)
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getLabRoleCv ({commit}, data) {
      return new Promise((resolve, reject) => {
        getLabRoleCv(data).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    modifyLabUserRole ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyLabUserRole(data).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getLabUserList ({commit}, data) {
      return new Promise((resolve, reject) => {
        getLabUserList(data).then((res) => {
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getLabUserListCount ({commit}, data) {
      return new Promise((resolve, reject) => {
        getLabUserListCount(data).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    insertLab ({commit}, data) {
      return new Promise((resolve, reject) => {
        insertLab(data).then((res) => {
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getListLab ({commit}, params) {
      return new Promise((resolve, reject) => {
        getListLab(params).then((res) => {
          commit('SET_LABLIST', res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    countListLab ({commit}, params) {
      return new Promise((resolve, reject) => {
        countListLab(params).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getLabById ({commit}, params) {
      return new Promise((resolve, reject) => {
        getLabById(params).then((res) => {
          commit('SET_LABDETAIL', res.result)
          resolve(res)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    updateLab ({commit}, params) {
      return new Promise((resolve, reject) => {
        updateLab(params).then((res) => {
          resolve()
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getLabMemebers ({commit}, data) {
      return new Promise((resolve, reject) => {
        getUserListByLabIdIsNull(data).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    delUserAndRoleFromLab ({commit}, data) {
      return new Promise((resolve, reject) => {
        removeUserAndRoleFromLab(data).then((res) => {
          console.log(res)
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    doQuitLab ({commit}, data) {
      return new Promise((resolve, reject) => {
        doQuitLab(data).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    },
    modifyLabNameInSample ({commit}, data) {
      return new Promise((resolve, reject) => {
        modifyLabNameInSample(data).then((res) => {
          resolve(res)
        }).catch(error => {
          console.log(error)
        })
      })
    }
  }
}
export default lab



// WEBPACK FOOTER //
// ./src/store/modules/admin/lab.js